import { Step } from './step.js';
import { Shepherd, Tour } from './tour.js';

Object.assign(Shepherd, { Tour, Step });

export default Shepherd;
